<template>
    <div
        class="app-container clearfix"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <div class="left300 right-20">
            <el-card class="el-brand">
                <div slot="header" class="clearfix">
                    <span class="ptitle">所属科目</span>
                </div>

                <div
                    v-for="(item, index) in subjectTypeList"
                    :class="{
                        activelist: active == item.subjectTypeId,
                        listitem: true,
                    }"
                    :key="index"
                    @click="selectType(item.subjectTypeId, item.subjectTypeName, item.moduleMark)"
                >
                    &nbsp;&nbsp;{{ item.subjectTypeName }}--{{ item.moduleMark }}
                </div>
            </el-card>
        </div>
        <div class="contentMode">
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-card>
                        <el-row>
                            <el-col style="padding: 10px 0 20px">
                                <el-button
                                    size="mini"
                                    type="primary"
                                    icon="el-icon-plus"
                                    class="pull-right"
                                    @click="addInfo"
                                    v-if="isGranted('Pages.SubjectFields.Create')"
                                    >新增</el-button
                                >
                            </el-col>
                        </el-row>
                        <el-table
                            :data="tableData"
                            size="mini"
                            style="width: 100%; margin-top: 10px"
                            border
                        >
                            <el-table-column
                                label="操作"
                                v-if="
                                    isGranted('Pages.SubjectFields.Delete') ||
                                        isGranted('Pages.SubjectFields.Edit')
                                "
                            >
                                <template slot-scope="scope">
                                    <el-tooltip content="编辑" placement="bottom">
                                        <el-button
                                            type="primary"
                                            icon="el-icon-edit"
                                            circle
                                            @click="editRow(scope.row.subjectField.id)"
                                            size="mini"
                                            v-if="isGranted('Pages.SubjectFields.Edit')"
                                        ></el-button>
                                    </el-tooltip>
                                    <el-tooltip content="删除" placement="bottom">
                                        <el-button
                                            type="danger"
                                            icon="el-icon-delete"
                                            circle
                                            @click="deleteEntity(scope.row.subjectField.id)"
                                            size="mini"
                                            v-if="isGranted('Pages.SubjectFields.Delete')"
                                        ></el-button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="name" label="字段名称" align="center">
                                <template slot-scope="scope">{{
                                    scope.row.subjectField.fieldName
                                }}</template>
                            </el-table-column>
                            <el-table-column prop="name" label="字段类型" align="center">
                                <template slot-scope="scope">{{
                                    scope.row.subjectField.fieldType
                                }}</template>
                            </el-table-column>
                            <!-- <el-table-column prop="name" label="数据来源" align="center">
                <template slot-scope="scope">{{scope.row.subjectField.dataSource}}</template>
              </el-table-column>-->
                            <el-table-column prop="name" label="所属科目" align="center">
                                <template slot-scope="scope">{{
                                    scope.row.subjectTypeSubjectTypeName
                                }}</template>
                            </el-table-column>
                            <!-- <el-table-column prop="name" label="所属科目" align="center">
                <template slot-scope="scope">{{scope.row.subjectType.subjectTypeName}}</template>
              </el-table-column>-->
                        </el-table>
                        <pagerBar
                            ref="refPagerBar"
                            :apiURL="subjectFieldUrl"
                            :GetData="initData"
                            :queryParam="queryParams"
                            :errorFunc="closeOpenloading"
                        ></pagerBar>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <el-dialog
            v-el-drag-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="38%"
            :before-close="handleClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-form
                label-width="110px"
                :model="formLabel"
                :rules="rules"
                ref="SubjectFieldEditForm"
            >
                <el-form-item label="字段名称" prop="fieldName">
                    <el-input v-model="formLabel.fieldName" placeholder="请输入字段名称"></el-input>
                </el-form-item>
                <el-form-item label="字段类型" prop="fieldType">
                    <el-select v-model="formLabel.fieldType" class="width100">
                        <el-option
                            key="selectOption"
                            label="selectOption"
                            value="selectOption"
                        ></el-option>
                        <el-option key="text" label="text" value="text"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属科目" prop="subjectTypeName">
                    <el-input v-model="formLabel.subjectTypeName" :disabled="true"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="SaveEntity()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import config from "@/common/config.js";
import AjaxHelper from "@/common/js/AjaxHelper";
import pagerBar from "@/views/pager/pagerBar";
export default {
    data() {
        return {
            activeMark: "",
            active: "", //菜单点击高亮效果
            //TODO
            openloading: true,
            dialogVisible: false, // 弹窗显示
            tableData: [],
            subjectTypeList: [],
            //得到科目类别的键值对
            getSubjectTypesUrl: config.BASE_Middle_API + "SubjectTypes/GetKeyValuesForSelect",
            //科目字段列表数据获取
            subjectFieldUrl: config.BASE_Middle_API + "SubjectFields/GetAll",
            //新增or修改
            createOrEditUrl: config.BASE_Middle_API + "SubjectFields/CreateOrEdit",
            //删除
            deleteUrl: config.BASE_Middle_API + "SubjectFields/Delete",
            //得到信息实体
            GetSubjectEntityUrl: config.BASE_Middle_API + "SubjectTypes/GetSubjectTypeForEdit",
            //得到信息实体
            GetEntityUrl: config.BASE_Middle_API + "SubjectFields/GetSubjectFieldForEdit",
            title: "",
            operation: "",
            formLabel: {
                id: null,
                fieldName: "",
                fieldType: "selectOption",
                subjectTypeId: 0,
                dataSource: "",
                subjectTypeName: "",
            },
            //已选择的科目类型ID
            selectTypeId: 0,
            queryParams: { SubjectTypeIdFilter: "0" },
            rules: {
                fieldName: [{ required: true, message: "请输入字段名称", trigger: "blur" }],
                fieldType: [{ required: true, message: "请选择字段类型", trigger: "blur" }],
                dataSource: [{ required: true, message: "请输入字段数据来源", trigger: "blur" }],
            },
        };
    },
    components: {
        pagerBar,
    },
    mounted: function() {
        this.getTypeKeyValues();
    },
    methods: {
        getTypeKeyValues() {
            const _this = this;
            AjaxHelper.get(_this.getSubjectTypesUrl)
                .then(function(response) {
                    if (response.success) {
                        _this.subjectTypeList = response.result;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        selectType(id, name, moduleMark) {
            const _this = this;
            _this.active = name;
            _this.activeMark = moduleMark;
            _this.selectTypeId = id;
            _this.queryParams.SubjectTypeIdFilter = id;
        },
        closeOpenloading() {
            this.openloading = false;
        },
        //新增科目字段
        addInfo() {
            const _this = this;
            if (_this.selectTypeId == 0) {
                _this.$notify({
                    title: "提示",
                    message: "请先选择左侧科目类别",
                    type: "error",
                    position: "bottom-right",
                });
                return;
            }
            _this.clearformLabel();
            _this.dialogVisible = true;
            _this.title = "新增" + _this.activeMark + _this.active + "字段";
            let confirmData = { Id: _this.selectTypeId };
            AjaxHelper.get(_this.GetSubjectEntityUrl, confirmData)
                .then(function(response) {
                    if (response.success) {
                        _this.dialogVisible = true;
                        _this.formLabel.subjectTypeName =
                            response.result.subjectType.subjectTypeName;
                        _this.formLabel.subjectTypeId = response.result.subjectType.id;
                        _this.formLabel.id = null;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.dialogVisible = true;
        },
        clearformLabel() {
            const _this = this;
            _this.formLabel.id = null;
            _this.formLabel.fieldName = "";
            _this.formLabel.fieldType = "";
            _this.formLabel.dataSource = "";
            _this.formLabel.subjectTypeId = null;
            _this.formLabel.subjectTypeName = "";
        },
        initData(d) {
            const _this = this;
            _this.tableData = d;
            _this.openloading = false;
        },
        //编辑
        editRow(id) {
            const _this = this;
            _this.title = "编辑" + _this.activeMark + _this.active + "字段";
            _this.operation = "edit";
            let confirmData = { Id: id };
            AjaxHelper.get(_this.GetEntityUrl, confirmData)
                .then(function(response) {
                    if (response.success) {
                        _this.dialogVisible = true;
                        _this.formLabel = response.result.subjectField;
                        _this.formLabel.subjectTypeName =
                            response.result.subjectTypeSubjectTypeName;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        deleteEntity(deletedId) {
            const _this = this;
            this.$confirm("确定删除该科目字段吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
            })
                .then(() => {
                    AjaxHelper.delete(_this.deleteUrl, {
                        Id: deletedId,
                    })
                        .then(function(response) {
                            if (response.success) {
                                _this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });
                                _this.Refresh();
                            }
                        })
                        .catch(function(error) {
                            _this.$message({
                                type: "danger",
                                message: error,
                            });
                        });
                })
                .catch((e) => {
                    _this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        //保存
        SaveEntity() {
            const _this = this;
            this.$refs["SubjectFieldEditForm"].validate((valid) => {
                let basicData = {};
                if (_this.operation == "edit") {
                    basicData = _this.formLabel;
                } else {
                    basicData = _this.formLabel;
                }

                if (valid) {
                    AjaxHelper.post(_this.createOrEditUrl, basicData)
                        .then(function(response) {
                            if (response.success) {
                                _this.$message({
                                    type: "success",
                                    message: "操作成功",
                                });
                                _this.pagesize = 1;
                                _this.clearformLabel();
                                _this.Refresh();
                                _this.dialogVisible = !_this.dialogVisible;
                            } else {
                                _this.$message({
                                    type: "error",
                                    message: response.Messages[0],
                                });
                            }
                        })
                        .catch(function(error) {
                            _this.$message({
                                type: "error",
                                message: error,
                            });
                        });
                }
            });
        },
        Refresh() {
            this.$refs.refPagerBar.Refresh();
        },
        handleClose(done) {
            done();
        },
    },
};
</script>

<style scoped="scoped">
dt,
dd {
    margin: 0;
    padding: 0;
}
</style>
